var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("b-card", { staticClass: "liveinfo-form", attrs: { "no-body": "" } }, [
        _c(
          "div",
          { staticClass: "m-2" },
          [
            _c(
              "b-row",
              [
                _c(
                  "b-col",
                  {
                    staticClass:
                      "d-flex align-items-center justify-content-start mb-1 mb-md-0",
                    attrs: { cols: "12" },
                  },
                  [
                    _c("b-form-input", {
                      staticClass: "el-def",
                      staticStyle: { width: "100px" },
                      attrs: { placeholder: "ID" },
                      model: {
                        value: _vm.query.liveInfoId,
                        callback: function ($$v) {
                          _vm.$set(_vm.query, "liveInfoId", $$v)
                        },
                        expression: "query.liveInfoId",
                      },
                    }),
                    _c("v-select", {
                      staticClass: "el-def",
                      attrs: {
                        options: _vm.codes.clients,
                        placeholder: "제약사",
                        reduce: function (option) {
                          return option.code
                        },
                      },
                      model: {
                        value: _vm.query.clientId,
                        callback: function ($$v) {
                          _vm.$set(_vm.query, "clientId", $$v)
                        },
                        expression: "query.clientId",
                      },
                    }),
                    _c("b-form-input", {
                      staticClass: "el-def",
                      staticStyle: { width: "180px" },
                      attrs: { placeholder: "제품명" },
                      model: {
                        value: _vm.query.brandName,
                        callback: function ($$v) {
                          _vm.$set(_vm.query, "brandName", $$v)
                        },
                        expression: "query.brandName",
                      },
                    }),
                    _c("b-form-input", {
                      staticClass: "el-def",
                      staticStyle: { width: "180px" },
                      attrs: { placeholder: "노출메시지" },
                      model: {
                        value: _vm.query.liveDiTitle,
                        callback: function ($$v) {
                          _vm.$set(_vm.query, "liveDiTitle", $$v)
                        },
                        expression: "query.liveDiTitle",
                      },
                    }),
                    _c("b-form-datepicker", {
                      staticClass: "el-def",
                      staticStyle: { width: "250px" },
                      attrs: { placeholder: "노출기간(Fr)" },
                      model: {
                        value: _vm.query.searchStartDate,
                        callback: function ($$v) {
                          _vm.$set(_vm.query, "searchStartDate", $$v)
                        },
                        expression: "query.searchStartDate",
                      },
                    }),
                    _vm._v(" ~ "),
                    _c("b-form-datepicker", {
                      staticClass: "el-def",
                      staticStyle: { width: "250px" },
                      attrs: { placeholder: "노출기간(To)" },
                      model: {
                        value: _vm.query.searchEndDate,
                        callback: function ($$v) {
                          _vm.$set(_vm.query, "searchEndDate", $$v)
                        },
                        expression: "query.searchEndDate",
                      },
                    }),
                    _c("v-select", {
                      staticClass: "invoice-filter-select el-def",
                      staticStyle: { width: "240px" },
                      attrs: {
                        options: _vm.codes.viewStatusType,
                        reduce: function (option) {
                          return option.code
                        },
                        placeholder: "노출상태",
                      },
                      model: {
                        value: _vm.liveType,
                        callback: function ($$v) {
                          _vm.liveType = $$v
                        },
                        expression: "liveType",
                      },
                    }),
                    _c(
                      "b-button",
                      {
                        staticClass: "btn-search",
                        attrs: { variant: "primary" },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.refreshLiveDiList()
                          },
                        },
                      },
                      [_vm._v(" 조회 ")]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _c(
        "b-card",
        { attrs: { "no-body": "" } },
        [
          _c(
            "div",
            { staticClass: "m-2" },
            [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    {
                      staticClass:
                        "d-flex align-items-center justify-content-start",
                      attrs: { cols: "12", md: "6" },
                    },
                    [
                      _c("h5", { staticClass: "mb-0 ml-50" }, [
                        _vm._v(
                          " 라이브 DI 리스트 [" +
                            _vm._s(_vm.totalRecords) +
                            "] 건 "
                        ),
                      ]),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c("b-table", {
            ref: "refLiveDiTable",
            staticClass: "position-relative",
            attrs: {
              "primary-key": "id",
              items: _vm.fetchLiveDiList,
              fields: _vm.tableColumns,
              "sort-by": _vm.sortBy,
              "sort-desc": _vm.isSortDesc,
              responsive: "",
              "sticky-header": "",
              selectable: "",
              "select-mode": "single",
            },
            on: {
              "update:sortBy": function ($event) {
                _vm.sortBy = $event
              },
              "update:sort-by": function ($event) {
                _vm.sortBy = $event
              },
              "update:sortDesc": function ($event) {
                _vm.isSortDesc = $event
              },
              "update:sort-desc": function ($event) {
                _vm.isSortDesc = $event
              },
              "row-selected": _vm.onRowSelected,
            },
            scopedSlots: _vm._u([
              {
                key: "cell(liveDiPeriod)",
                fn: function (data) {
                  return [
                    _c("span", { staticClass: "text-nowrap" }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm._f("$dateFormatter")(
                              data.item.liveDiStartDate,
                              "YYYY-MM-DD"
                            )
                          ) +
                          " ~ " +
                          _vm._s(
                            _vm._f("$dateFormatter")(
                              data.item.liveDiEndDate,
                              "YYYY-MM-DD"
                            )
                          ) +
                          " "
                      ),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { cols: "12" } },
                [
                  _c("b-pagination", {
                    attrs: {
                      "total-rows": _vm.totalRecords,
                      limit: "10",
                      "per-page": "5",
                      align: "center",
                    },
                    model: {
                      value: _vm.currPage,
                      callback: function ($$v) {
                        _vm.currPage = $$v
                      },
                      expression: "currPage",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "b-card",
        [
          _c(
            "b-tabs",
            { attrs: { pills: "" } },
            [
              _c("b-tab", {
                attrs: { title: "지역·진료과별 통계" },
                on: {
                  click: function ($event) {
                    _vm.viewType = "region-dept"
                  },
                },
              }),
              _c("b-tab", {
                attrs: { title: "요양기관 리스트" },
                on: {
                  click: function ($event) {
                    _vm.viewType = "hcp"
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "b-card",
        [
          _vm.viewType === "region-dept"
            ? _c("region-dept-view", {
                attrs: {
                  "liveinfo-id": _vm.selectedLiveInfoId,
                  "selected-data": _vm.selectedData,
                },
              })
            : _vm.viewType === "hcp"
            ? _c("hcp-work-place-view", {
                attrs: {
                  "liveinfo-id": _vm.selectedLiveInfoId,
                  "selected-data": _vm.selectedData,
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }